import { memo, useCallback } from "react";
import styled from "styled-components";

const fallback = "/images/poster-fallback.jpg"; // add a tiny placeholder image in public

// proxy config
const PROXY_BASE = process.env.REACT_APP_IMG_PROXY || "https://api.fansfolder.com";
const toProxied = (url) =>
  url ? `${PROXY_BASE}/img?u=${encodeURIComponent(url.split("?")[0])}` : "";


const TrendingPoster = memo(function TrendingPoster({ rank, posterUrl, onClick }) {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick?.();
      }
    },
    [onClick]
  );

  return (
    <PosterWrapper
      role="button"
      tabIndex={0}
      aria-label={`Open movie ${rank}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <Content>
        <PosterImg
          src={toProxied(posterUrl)}
          alt=""
          loading="lazy"
          decoding="async"
          onError={(e) => {
            e.currentTarget.src = fallback;
          }}
        />
        <RankBadge aria-hidden="true">{rank}</RankBadge>
      </Content>
    </PosterWrapper>
  );
});

export default TrendingPoster;

const PosterWrapper = styled.div`
  flex: 0 0 auto;
  cursor: pointer;
  transition: transform 0.3s ease;
  transform-origin: center center;
  outline: none;

  &:hover {
    transform: scale(1.05);
  }

  &:focus-visible {
    outline: 2px solid #4da3ff;
    outline-offset: 4px;
  }
`;

const Content = styled.div`
  position: relative;
  width: 195px;
  margin-top: 10px;

  @media (max-width: 968px) {
    width: 120px;
  }
`;

const PosterImg = styled.img`
  width: 100%;
  aspect-ratio: 5 / 7;
  object-fit: cover;
  background: #2c2c2c;
  border-radius: 8px;
  overflow: hidden;
  display: block;
`;

const RankBadge = styled.div`
  position: absolute;
  bottom: 20px;
  left: -20px;
  font-size: 136px;
  font-weight: 900;
  color: black;
  -webkit-text-stroke: 2px #f7c23d;
  line-height: 0.9;
  z-index: 2;
  pointer-events: none;

  @media (max-width: 968px) {
    bottom: 20px;
    left: -10px;
    font-size: 80px;
    -webkit-text-stroke: 1.5px #f7c23d;
    line-height: 0.7;
  }
`;
